import { render } from "./RegisterFormPart.vue?vue&type=template&id=2aed84a8"
import script from "./RegisterFormPart.vue?vue&type=script&lang=js"
export * from "./RegisterFormPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__